module.exports = __webpack_public_path__ + "static/img/BG.b5e9be85.png";